import { createContext, useCallback, useContext, useEffect, useState } from "react";

const API_URL = process.env.REACT_APP_BACKEND_URL;
const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const res = await fetch(`${API_URL}/api/auth/me`, { credentials: "include" });
      if (res.ok) setUser(await res.json());
      else setUser(null);
    } catch { setUser(null); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const login = useCallback(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const current = window.location.pathname + window.location.search;
    try { sessionStorage.setItem("bb_return_to", current); } catch {}
    window.location.href = `${API_URL}/api/auth/google/login`;
  }, []);

  const logout = useCallback(async () => {
    try { await fetch(`${API_URL}/api/auth/logout`, { method: "POST", credentials: "include" }); } catch {}
    setUser(null);
    window.location.href = "/";
  }, []);

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout, refresh: checkAuth, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);

export const authFetch = (path, opts = {}) =>
  fetch(`${API_URL}${path}`, { ...opts, credentials: "include" });
